export type SingleRequest = {
	userReqId: number;
	requestorMsisdn: string;
	userReqType: string;
	amount: number;
	reqParam: any;
	createdAt: string;
	updatedAt: string;
	requestorUpId: number;
	recipientUpId: number;
	status: string;
	updatedBy: string;
	updatedByObjectId: string;
};

const model: types.models.InputModel = {
	userReqId: 'userReqId',
	requestorMsisdn: 'requestorMsisdn',
	userReqType: 'userReqType',
	amount: 'amount',
	reqParam: 'reqParam',
	createdAt: 'createdAt',
	updatedAt: 'updatedAt',
	requestorUpId: 'requestorUpId',
	recipientUpId: 'recipientUpId',
	status: 'status',
	updatedBy: 'updatedBy',
	updatedByObjectId: 'updatedByObjectId',
};

export default model;
